import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=50e17198&"
import script from "./Unauthorized.vue?vue&type=script&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e17198')) {
      api.createRecord('50e17198', component.options)
    } else {
      api.reload('50e17198', component.options)
    }
    module.hot.accept("./Unauthorized.vue?vue&type=template&id=50e17198&", function () {
      api.rerender('50e17198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Unauthorized.vue"
export default component.exports